import {Grid} from '@mui/material';
import {CommonFields} from '../CommonFields';
import {List} from './List';
import {useFormContext} from 'react-hook-form';

export const Activities = () => {
  const {
    watch,
    formState: {errors},
  } = useFormContext();

  const values = watch('menus.navigations.activities');
  return (
    <Grid container>
      <Grid item md={12}>
        <CommonFields name={'menus.navigations.activities'} />
      </Grid>
      <Grid item md={12}>
        <List
          name='menus.navigations.activities.list'
          values={values?.list}
          errors={errors?.menus?.navigations?.activities?.list}
        />
      </Grid>
    </Grid>
  );
};
